import _typeof from "/var/jenkins_home/workspace/mka-pc_prod/node_modules/@babel/runtime/helpers/typeof.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/esnext.iterator.map.js";
export default {
  name: 'pc-floor',
  props: {
    widgets: {
      type: Object,
      default: function _default() {
        return {
          title: '楼层组',
          icon: 'el-icon-menu',
          content: {
            data: [],
            line: '',
            title: '',
            adImg: '',
            adLink: {},
            link: {}
          },
          config: [{
            label: '标题',
            name: 'title',
            type: 'input',
            value: '最新咨询'
          }, {
            label: '广告图(247*608)',
            name: 'adImg',
            type: 'image',
            value: ''
          }, {
            label: '广告图链接',
            name: 'adLink',
            type: 'link',
            value: ''
          }, {
            label: '更多链接',
            name: 'link',
            type: 'link',
            value: ''
          }, {
            label: '商品数据',
            name: 'data',
            type: 'goods-select',
            value: []
          }, {
            label: '行数',
            name: 'line',
            type: 'radio-button',
            options: [{
              label: '一个',
              value: '!grid-cols-1'
            }, {
              label: '二个',
              value: '!grid-cols-2'
            }, {
              label: '三个',
              value: '!grid-cols-3'
            }, {
              label: '四个',
              value: '!grid-cols-4'
            }]
          }]
        };
      }
    }
  },
  data: function data() {
    return {
      list: []
    };
  },
  computed: {},
  created: function created() {
    if (this.widgets.content.data) {
      var data = this.widgets.content.data[0];
      if (_typeof(data) != 'object') {
        this.getItem();
      }
    }
  },
  mounted: function mounted() {},
  methods: {
    getItem: function getItem() {
      var _this = this;
      var idList = this.widgets.content.data;
      var ids = this.list.map(function (item) {
        return item.id;
      });
      if (!this.isEqual(ids, idList)) {
        if (idList && idList.length) {
          this.apiPost('/bbb/goodsInfo/listData', {
            idList: idList,
            sortByParamId: true
          }).then(function (res) {
            var jsonArray = res.data;
            _this.list = jsonArray;
          });
        }
      }
    }
  }
};